import { User, AppRole } from "@/domain/entities/User";
import { Email } from "@/domain/value-objects/Email";
import { Database } from "@/types/database";

type ProfileRow = Database["public"]["Tables"]["profiles"]["Row"];

/**
 * Mapper: Database Row ↔ User Entity
 */
export class UserMapper {
  static toDomain(row: ProfileRow, email: string): User {
    const rowAny = row as unknown;
    return User.restore({
      id: row.id,
      clinicId: row.clinic_id ?? "",
      email: Email.create(email),
      fullName: row.full_name ?? "Usuário",
      // @ts-expect-error — TS18046
      appRole: (rowAny.app_role as AppRole) ?? "MEMBER",
      // @ts-expect-error — TS18046
      isActive: rowAny.is_active ?? true,
      avatarUrl: row.avatar_url ?? undefined,
      // @ts-expect-error — TS18046
      phone: rowAny.phone ?? undefined,
      createdAt: new Date(row.created_at),
      updatedAt: new Date(row.updated_at),
    });
  }

  static toPersistence(user: User): unknown {
    return {
      id: user.id,
      clinic_id: user.clinicId,
      full_name: user.fullName,
      app_role: user.appRole,
      is_active: user.isActive,
      avatar_url: user.avatarUrl ?? null,
      phone: user.phone ?? null,
    };
  }
}
